import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import Seo from "@/components/Seo";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Please sign in.");
      navigate("/admin/login", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Seo title="Set New Password" path="/reset-password" />
      <div className="flex min-h-screen items-center justify-center bg-[#133827] px-4">
        <div className="w-full max-w-md rounded-3xl bg-white p-8 shadow-2xl sm:p-10">
          <h1 className="font-display text-2xl font-bold text-[#18201B]">Set a new password</h1>
          {!token ? (
            <p className="mt-4 text-sm text-destructive">This reset link is invalid or incomplete.</p>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4" data-testid="reset-form">
              <div>
                <Label htmlFor="password">New password</Label>
                <Input id="password" type="password" required minLength={8} data-testid="reset-password-input" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" />
              </div>
              {error && <p className="text-sm text-destructive">{error}</p>}
              <Button type="submit" disabled={loading} data-testid="reset-submit-btn" className="w-full bg-[#133827] text-white hover:bg-[#0d261a]">
                {loading ? "Saving…" : "Reset Password"}
              </Button>
            </form>
          )}
          <Link to="/admin/login" className="mt-4 inline-block text-sm text-[#2C5E43] hover:underline" data-testid="reset-back-link">← Back to sign in</Link>
        </div>
      </div>
    </>
  );
}
